import { render, staticRenderFns } from "./foodMaterial.vue?vue&type=template&id=329a6be6&scoped=true&"
import script from "./foodMaterial.vue?vue&type=script&lang=js&"
export * from "./foodMaterial.vue?vue&type=script&lang=js&"
import style0 from "./foodMaterial.vue?vue&type=style&index=0&id=329a6be6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a6be6",
  null
  
)

component.options.__file = "foodMaterial.vue"
export default component.exports